/**
 * Initializes the parallax on images with class parallax
 */
function initParallax() {
	let windowHeight = window.innerHeight;

	document.addEventListener( 'resize', function () {
		windowHeight = window.innerHeight;
	} );

	function outerHeight( el ) {
		let height = el.offsetHeight;
		let style = getComputedStyle( el );

		height += parseInt( style.marginTop ) + parseInt( style.marginBottom );
		return height;
	}

	function parallax( el, speedFactor, outerHeight ) {
		let foo = document.querySelectorAll( el );

		let getHeight;
		let firstTop;
		let paddingTop = 0;

		//get the starting position of each element to have parallax applied to it
		foo.forEach( function ( subEl ) {
				firstTop = subEl.getBoundingClientRect().top;
		} );

		if ( outerHeight ) {
			getHeight = function ( el ) {
				return outerHeight( el );
			};
		} else {
			getHeight = function ( el ) {
				return el.clientHeight;
			};
		}

		// function to be called whenever the window is scrolled or resized
		function update() {
			let pos = window.scrollY;

			foo.forEach( function ( subEl ) {
				let element = subEl;
				let top = element.getBoundingClientRect().top;
				let height = getHeight( element );
				let speed = subEl.getAttribute( 'data-speed' );

				if ( speed ) {
					speedFactor = speed;
				}

				element.style.top = - (
					Math.round( (
						            firstTop - pos
					            ) * speedFactor )
				) + 'px';
			} );
		}

		document.addEventListener( 'scroll', update, true );
		document.addEventListener( 'resize', update );
		update();
	};

	parallax( '.parallax', - 0.5 );
}

export default {
	init() {
		if ( window.outerWidth > 1440 ) {
			initParallax();
		}
	},
};